import React from 'react'
import { WiserPromptPopup } from './WiserPromptPopup'

export interface WiserHubPromptPopupProps {
  onAction: (params: {
    shouldAddWiserHub: boolean
    doNotAskAgain: boolean
    ctaName: string
  }) => void
}

export function WiserHubPromptPopup({
  onAction,
}: WiserHubPromptPopupProps) {
  const onAddWiserHub = (doNotAskAgain: boolean) => onAction({
    shouldAddWiserHub: true,
    doNotAskAgain,
    ctaName: 'Yes',
  })

  const onDoNotAddWiserHub = (doNotAskAgain: boolean) => onAction({
    shouldAddWiserHub: false,
    doNotAskAgain,
    ctaName: 'No',
  })

  return (
    <WiserPromptPopup
      onYes={onAddWiserHub}
      onNo={onDoNotAddWiserHub}
    >
      This requires a Wiser Hub
      <div style={{ paddingBottom: '0.5em' }} />
      Do you want to add one to your list?
    </WiserPromptPopup>
  )
}
